module.exports = __webpack_public_path__ + "img/studomat1.6bfffe63.png";